/** The protocols on the left; the one picked on the right, as Live Promote when it is live. */

import { useState } from 'react';
import { Link } from 'react-router';
import type { ProtocolSummary } from '@/modules/promotion/types';
import { LivePromote } from '../live/live-promote';
import { ProtocolList } from './protocol-list';

const NotLive = ({ name }: { name: string }) => (
	<div className='flex flex-col gap-1 p-4 text-xs leading-4 text-gray-800'>
		<p>
			<span className='font-medium text-text-heading capitalize'>{name}</span> is not live, so Kim has answered no
			tickets on it yet.
		</p>
		<p>
			Turn it on in{' '}
			<Link to='/training/protocols' className='font-medium text-indigo-700'>
				Protocols
			</Link>
			.
		</p>
	</div>
);

export const ProtocolsTab = () => {
	const [selected, setSelected] = useState<ProtocolSummary | null>(null);
	return (
		<div className='grid min-h-0 flex-1 grid-cols-[minmax(240px,30%)_minmax(0,1fr)] rounded-md border'>
			<div className='flex min-h-0 min-w-0 flex-col border-r border-gray-500'>
				<ProtocolList selectedId={selected?.sopId ?? null} onSelect={setSelected} />
			</div>
			<div className='flex min-h-0 min-w-0 flex-col'>
				{!selected ? (
					<p className='p-4 text-xs leading-4 text-gray-800'>
						Pick a live protocol to promote replies from the tickets Kim already answered on it.
					</p>
				) : selected.live ? (
					<LivePromote key={selected.sopId} sopId={selected.sopId} />
				) : (
					<NotLive name={selected.name} />
				)}
			</div>
		</div>
	);
};
